import { Trans } from 'react-i18next';

import { Button } from '@actual-app/components/button';

import { color } from '#components/mobile/ui/tokens';

type BotonAnularEnlaceProps = {
  'data-testid': string;
  onPress: () => void;
  alinearAlCentro?: boolean;
};

/** «Anular enlace» como texto de color, en la fila y en el enlace recién creado. */
export function BotonAnularEnlace({
  'data-testid': testId,
  onPress,
  alinearAlCentro = false,
}: BotonAnularEnlaceProps) {
  return (
    <Button
      variant="bare"
      data-testid={testId}
      onPress={onPress}
      style={{
        alignSelf: alinearAlCentro ? 'center' : undefined,
        padding: '12px 10px',
        borderRadius: 10,
        fontSize: 13.5,
        fontWeight: 800,
        color: color.accent,
      }}
    >
      <Trans>Cancel link</Trans>
    </Button>
  );
}
